import config from '../config';
import { logAction } from '../services/actionLogger';

export async function log(action, params) {
    if (config.actionLogging.logToConsole) console.log('[ACTION LOGGER] ', action, params); // eslint-disable-line

    return logAction(action, params);
}
